import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const JobDescription_Box_1 = styled.div`
  padding-bottom: 12px;
  padding-inline: 24px;
  padding-top: 12px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    padding-bottom: 24px;
    padding-inline: 44px;
  }
`;
